import type { TPriceDataRawProcess } from '~/src/types/prices-chart'

export function getHasPayableAndPrice(
  _item: TPriceDataRawProcess,
  payable: boolean,
  price: boolean,
) {
  if (
    _item?.priceType?.name === 'Payable' ||
    _item?.unitOfMeasure?.name === 'Percentage'
  ) {
    payable = true
  } else {
    price = true
  }
  return { payable, price }
}

export function getHasGrade(_item: TPriceDataRawProcess, grade: boolean) {
  if (_item?.grade) {
    return true
  }
  return grade
}

export function getHasMeshSize(_item: TPriceDataRawProcess, meshSize: boolean) {
  if (_item?.meshSize?.size) {
    return true
  }
  return meshSize
}

export function getHasSustainableGrade(
  _item: TPriceDataRawProcess,
  sustainableGrade: boolean,
) {
  if (_item?.category?.isSustainable || _item?.feedstock?.isSustainable) {
    return true
  }
  return sustainableGrade
}

export function getHasValueByProperty(
  property: string,
  _item: TPriceDataRawProcess,
  product: boolean,
) {
  if (_item[property]?.name) {
    return true
  }
  return product
}

export function getLengthMarket(
  _item: TPriceDataRawProcess,
  lengthMarket: number,
) {
  if (_item?.Product?.ProductName?.length > 12) {
    lengthMarket = 170
  }

  return lengthMarket
}
